export const resetFetching = () => ({
  type: "RESET_FETCHING"
});

export const fetchItems = resp => ({
  type: "FETCH_ITEMS",
  payload: resp
});

export const setFetchingId = id => ({
  type: "SET_FETCHING_ID",
  id
});
export const setFetchingItems = items => ({
  type: "SET_FETCHING_ITEMS",
  items
});



// WEBPACK FOOTER //
// ./src/actions/actions/fetching.js